import { Factory } from './Factory'
export class FormInputFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  create() {
    return {
      id: this.id('form-input'),
      component: 'editor-form-input',
      content: {
        name: 'name',
        label: 'label',
        placeholder: 'placeholder',
        type: 'text',
        options: [],
        required: false
      }
    }
  }
}